interface DecodedToken {
  unique_name: number;
  email: string;
  demo_flag: string;
  userId: number;
  companyId: number;
  channelSiteId: number;
  iat: number;
  exp: number;
}

export const getTokenFromCookie = (): string | null => {
  const cookies = document.cookie.split(';');
  const jtTokenCookie = cookies.find(cookie => cookie.trim().startsWith('jtToken='));
  
  if (!jtTokenCookie) {
    return null;
  }

  return jtTokenCookie.split('=')[1].trim();
}

export const getCompanyIdFromToken = (): number | null => {
  try {
    // Get token from cookie
    const token = getTokenFromCookie();

    //For local testing
    // const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6MTA1ODc2OSwiZW1haWwiOiJsLmFsZmFyb0Bqb2J0YXJnZXQuY29tIiwiZGVtb19mbGFnIjoiMCIsInVzZXJJZCI6MTA1ODc2OSwiY29tcGFueUlkIjo2NDQ0LCJjaGFubmVsU2l0ZUlkIjoxLCJpYXQiOjE3NDIyMzM5MDMsImV4cCI6MTc0MjMyMDMwM30.lYpM2KV2Rk3jlAedpPpDgZJRI1e1P8sZ_pb5iYVCj7U"
    
    
    if (!token) {
      return null;
    }

    // Get the payload part of the JWT (second part)
    const payload = token.split('.')[1];
    
    // Decode the base64 string
    const decodedPayload = JSON.parse(atob(payload));
    // console.log("Decoded payload", decodedPayload);
    
    return decodedPayload.companyId;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
}

// Optional: Get full decoded token if you need other properties
export const getDecodedToken = (): DecodedToken | null => {
  try {
    const token = getTokenFromCookie();
    
    if (!token) {
      return null;
    }

    const payload = token.split('.')[1];
    return JSON.parse(atob(payload));
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
} 